module.exports = __webpack_public_path__ + "img/famous_p7.42d22388.png";